
export const _genAutosaveStatusMsg = (saveStatus) => {
    return saveStatus === "idle"
      ? ""
      : saveStatus === "loading"
      ? "Saving..."
      : saveStatus === "error"
      ? "Save Failed"
      : saveStatus === "success" && "Saved!";
  };